import React from "react";
import CrudPage from "./CrudPage";

const STATUSES = ["draft", "planned", "in_progress", "scheduled", "published", "archived"];

export default function ContentPlans() {
  return (
    <CrudPage
      title="Content Plans"
      subtitle="Editorial structures and publishing priorities (SEO Studio §8)."
      testIdPrefix="plan"
      listUrl="/seo/content-plans?limit=200"
      createUrl="/seo/content-plans"
      updateUrl={(id) => `/seo/content-plans/${id}`}
      deactivateUrl={(id, r) => `/seo/content-plans/${id}/deactivate?change_reason=${encodeURIComponent(r)}`}
      columns={[
        { key: "title", label: "Title" },
        { key: "slug", label: "Slug" },
        { key: "status", label: "Status" },
        { key: "publish_priority", label: "Priority" },
      ]}
      fields={[
        { key: "title", label: "Title", type: "text" },
        { key: "slug", label: "Slug (lowercase, hyphenated)", type: "text",
          placeholder: "asia-sourcing-guide" },
        { key: "status", label: "Status", type: "select", options: STATUSES },
        { key: "publish_priority", label: "Publish priority (1–10)", type: "number" },
        { key: "target_publish_date", label: "Target publish date", type: "text",
          placeholder: "2026-08-15" },
      ]}
      emptyForm={{
        title: "", slug: "", status: "draft",
        publish_priority: "5", target_publish_date: "",
      }}
      fromRow={(row) => ({
        title: row.data.title, slug: row.data.slug,
        status: row.data.status, publish_priority: row.data.publish_priority ?? 5,
        target_publish_date: row.data.target_publish_date || "",
      })}
      canonicalizeCreate={(f) => ({
        title: f.title, slug: f.slug, status: f.status,
        publish_priority: Number(f.publish_priority),
        target_publish_date: f.target_publish_date || null,
      })}
      canonicalizeUpdate={(f) => ({
        title: f.title, status: f.status,
        publish_priority: Number(f.publish_priority),
        target_publish_date: f.target_publish_date || null,
        change_reason: "edited via admin UI",
      })}
    />
  );
}
